import { createElementFromHTML, getSubscriptionDefitionNode, getTranslatedDefinition, setSubscriptionIdsNode } from '../utils/common';
import { DOM_IDS } from '../utils/constants';
export default function loadArchivedSubscription({
  archivedSubscription,
  sentSubscriptionId
}) {
  if (!archivedSubscription) {
    return;
  }
  const placeHolderDiv = document.getElementById(DOM_IDS.archivedType);
  let subscriptionNode = '';
  if (archivedSubscription) {
    const subscriptionDefinition = getTranslatedDefinition(archivedSubscription);
    subscriptionNode = getSubscriptionDefitionNode({
      subscribed: archivedSubscription.checkboxChecked,
      name: subscriptionDefinition.name,
      description: subscriptionDefinition.description,
      category: subscriptionDefinition.process,
      channel: subscriptionDefinition.operation,
      id: archivedSubscription.id
    }, sentSubscriptionId);
    setSubscriptionIdsNode(archivedSubscription.id);
  }
  const itemClass = ['item'];
  const subscriptionElement = `
    <div class="${itemClass.join(' ')}" data-test-id="archived-subscription">
      ${subscriptionNode}
    </div>
  `;
  placeHolderDiv && placeHolderDiv.replaceWith(createElementFromHTML(subscriptionElement));
}